module.exports = __webpack_public_path__ + "img/成果展示国企单位.d8339c4a.png";